import React from 'react';
import { Controller } from 'react-hook-form';

const SingleReactHookFormWrapper = ({
  element,
  control,
  errors,
  className,
  name,
  isPassword,
  required,
  customProps = {},
}) => {
  const injectProps = (element, props) => {
    if (React.isValidElement(element)) {
      const children = React.Children.toArray(
        element.props.children
      );
      const newElement = React.cloneElement(element, props);
      const newChildren = children.map((child) =>
        injectProps(child, props)
      );
      return React.cloneElement(
        newElement,
        {},
        newChildren
      );
    } else {
      return element;
    }
  };
  return (
    <React.Fragment>
      <div className={className}>
        <Controller
          rules={{ required: required ?? false }}
          control={control}
          name={name}
          render={({ field: { onChange, value } }) =>
            injectProps(element, {
              onChange,
              errors,
              name,
              ...(isPassword ? { isPassword } : {}),
              value,
              ...customProps,
            })
          }
        />
      </div>
    </React.Fragment>
  );
};

export default SingleReactHookFormWrapper;
